import { create, reciept, cancelScheduledPayment, quickCreate, emailReciept } from "api/payment";
/**
 * Wrapper for all ajax activity for Payment creation
 */
class PaymentRepository {
    /**
     * Create payment on the API
     * @param {Object} payment
     * @returns {axios.Promise}
     */
    createPayment(payment) {
        return create(payment).then(({ data }) => data);
    }
    createQuickPayment(payment) {
        return quickCreate(payment).then(({ data }) => data);
    }
    loadReceipt(id) {
        return reciept(id).then(({ data }) => data);
    }
    emailReceipt(id) {
        return emailReciept(id).then(({ data }) => data);
    }
    cancelPayment(id) {
        return cancelScheduledPayment(id);
    }
}
export default new PaymentRepository();



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/payment/PaymentRepository.ts